export default "__VITE_ASSET__7af1b08e__"